import { registerReactControllerComponents } from '@symfony/ux-react';
import '../../bootstrap.js';

registerReactControllerComponents(
    require.context(
        '../controllers',
        true,
        /RyderLivescoring\.(j|t)sx?$/
    )
);
